module.exports = __webpack_public_path__ + "img/smart_agro.25fd13e9.svg";